import { LogoIcon } from '../../icons'

export function Footer() {
  return (
    <div className="ap:w-full ap:pb-4xl ap:pt-3xl ap:mt-4xl ap:border-t-stroke-accent ap:border ap:border-transparent ap:flex ap:justify-between">
      <div className="ap:flex ap:flex-col ap:gap-md  *:ap:cursor-pointer">
        <a
          href="//autoplan.no/om-oss"
          target="_blank"
          rel="noopener"
          className="ap:text-content-primary ap:hover:text-primary ap:hover:font-semibold"
        >
          Om Autoplan
        </a>
        <a href="/help" className="ap:text-content-primary ap:hover:text-primary ap:hover:font-semibold">
          Kontakt oss
        </a>
      </div>
      <LogoIcon />
    </div>
  )
}
